module.exports = __webpack_public_path__ + "static/media/icon_bank_logo.5fc5a7c8.png";